// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OImu","toggle":"styles_toggle__1sxTr","preview":"styles_preview__1BGLX"};